import { userRoles } from "../contexts/AuthProvider/AuthProvider";

export const rolesDashboards = {
  [userRoles.ADMIN]: "/dashboard"
};
